export const getTruncatedName = (name: string, maxLength = 100): string =>
  name.length <= maxLength ? name : name.slice(0, maxLength) + '...';